import React from 'react'
import { useSelector } from 'react-redux'

export function TableTrainerStreetPot() {
	const { table } = useSelector((state) => state.view)

	const streetPot = table && table.pot

	const containerWidth = streetPot >= 100 ? 77 : streetPot >= 10 ? 70 : 49
	const rectWidth = streetPot >= 100 ? 47 : streetPot >= 10 ? 40 : 33

	return (
		<>
			{streetPot !== 0 && (
				<svg
					width={containerWidth}
					height='21'
					viewBox='0 0 49 21'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
					x={streetPot >= 10 ? '41.5%' : '44%'}
					y={130}
				>
					<g mask='url(#mask0_2936_72805)'>
						<circle cx='7' cy='10.5' r='6.5' fill='#303034' />
					</g>

					<rect x='15.5' width={rectWidth} height='21' rx='10.5' fill='#D9D9D9' style={{ opacity: 0.3 }} />
					<text x='40%' y='68%' fontSize='11px' fontWeight='400' fill={'#fff'}>
						{streetPot.toFixed(2)}
					</text>
				</svg>
			)}
		</>
	)
}
